import { useStore } from 'effector-react'
import { $properties, getProperties } from './model'

export const usePropertyList = () => {
  const loading = useStore(getProperties.pending)

  const properties = useStore($properties)

  return { properties, loading }
}
